"use client";

import { c as _c } from "react/compiler-runtime";
import type { ErrorBoundaryProps } from "../../types/error-boundary";

// this only fires when the root layout itself threw, so there
// one shared copy for every app. The branded 500 page lives in error.tsx, which renders inside the layout and does have translations.
export function GlobalErrorShell(t0) {
  const $ = _c(13);
  const {
    error,
    reset,
    retry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>Error</title>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h1 className="font-bold text-2xl">Something went wrong</h1>;
    t3 = <p>An unexpected error occurred. Please reload the page or return to the homepage.</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== error.digest) {
    t4 = error.digest && <p className="text-sm opacity-70">Error ID: {error.digest}</p>;
    $[3] = error.digest;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = retry ?? reset;
  let t6;
  if ($[5] !== t5) {
    t6 = <button className="font-bold underline underline-offset-4" onClick={t5} type="button">Reload page</button>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <a className="underline underline-offset-4" href="/">Homepage</a>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6) {
    t8 = <div className="flex justify-center gap-6">{t6}{t7}</div>;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4 || $[11] !== t8) {
    t9 = <html lang="en"><body>{t1}<main className="mx-auto grid min-h-screen max-w-xl place-content-center gap-4 px-6 text-center">{t2}{t3}{t4}{t8}</main></body></html>;
    $[10] = t4;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
}